module.exports = __webpack_public_path__ + "img/elec1_hover.a8266050.png";